<template>
  <div>
    <p class="bottom-text">
      I agree to abide by the <ASCAArtIncLink />, <BylawsLink />, and rules of the ASCA Registry and all other ASCA programs.
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ASCAArtIncLink from "./ASCAArtIncLink.vue";
import BylawsLink from "./BylawsLink.vue";

export default Vue.extend({
  name: "KennelSignatureText",
  components: { ASCAArtIncLink, BylawsLink }
});
</script>